export default __webpack_public_path__ + "static/media/down.170ae084.png";